export default function mapIds<T extends { Id: string }>(list: T[]) {
  return list.map((item) => item.Id);
}
